<template>
    <div>
        <div class="breadcrumbs">
            <div class="col-sm-4">
                <div class="page-header float-left">
                    <div class="page-title">
                        <h1>오더 정보 등록</h1>
                    </div>
                </div>
            </div>            
        </div>        
        <b-container fluid class="animated fadeIn">
            <div class="card">
                <div class="card-header">
                    <strong class="card-title">오더 엑셀 등록</strong>
                </div>
                <b-card-body>
                    
                    <div class="ml-3 float-right">                        
                        <b-form-file v-model="file" ref="excel_file" :state="Boolean(file)" placeholder="엑셀파일등록" @change="_change" accept=".xls, .xlsx"></b-form-file> 
                        <b-form-file v-model="file" ref="excel_file" :state="Boolean(file)" placeholder="엑셀파일등록_신규" @change="_change_new" accept=".xls, .xlsx"></b-form-file> 
                    </div>                   
                    <b-table 
                        show-empty
                        empty-text="조회된 내용이 없습니다."
                        empty-filtered-text="조회된 내용이 없습니다."
                        fixed="fixed"
                        responsive="sm" 
                        :small="true"                          
                        :striped="false" 
                        :bordered="true"  
                        hover                                 
                        :items="items" 
                        :fields="fields">                                                                                   
                    </b-table>
                    <div class="mb-1 mt-2 float-right" v-if="items.length > 0">
                        <b-row align-h="end" align-v="center">
                            <b-col  md="auto">
                                <b-button class="mb-2" size="" variant="primary" @click="addOrders">오더 등록</b-button>
                            </b-col>
                            <b-col md="auto">
                                <download-excel
                                    name = '등록오류건.xls'
                                    :data   = items
                                    :fields = "json_fields">                            
                                    <img src="/static/images/download-to-excel-icon-0.jpg" width="50" height="50" alt="">
                                </download-excel>
                            </b-col>
                        </b-row>                                                
                    </div>                    
                </b-card-body>
            </div>            
        </b-container>    
    </div>
</template>
<script>
import {order} from '../data/table.js'
import employeeApi from '../api/employee'
import ResultMessage from '../data/resultMessage'
import kakaoApi from '../api/kakao'
import {mapGetters} from 'vuex'
import _ from 'lodash'
import JsonExcel from 'vue-json-excel'
import XLSX from 'xlsx';
import * as types from '../store/mutation-types'

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x,i) => ({name:XLSX.utils.encode_col(i), key:i}));
const sleep = ms => new Promise(r => setTimeout(r, ms));

export default {
    name: 'regOrder',
    components: {        
        //Datepicker
        //'ag-grid-vue': AgGridVue
        'downloadExcel': JsonExcel
    },
    data() {
        return {
            fields: order.fields,
            items: [],    
            tempItems: [],        
            currentPage: 1,
            perPage: 5,
            totalRows: 0,
            filter: null,
            department: null,
            isModify: false,
            state: {
                tickets:[{name:"test"}],
                headers:["Test header"]
            },
            file: null,
            data: [],
            json_fields: {
                '접수시간' : 'reqDate',
                '주문자(어드바이저)' : 'reqUserName',
                '주문자 연락처' : 'reqUserPhoneNo',
                '보내는 분 연락처' : 'startPhoneNo',
                '보내는분 주소' : 'startAddr',
                '받는분 구분' : 'receiverType',
                '받는분 성함' : 'receiverName',
                '받는분 연락처' : 'receiverPhoneNo',
                '받는분 주소' : 'receiverAddr',
                '예약시간' : 'reservDate',
                '차량번호' : 'carNo',
                '빠른배차/왕복' : 'option',
                '특이사항' : 'etc'
            },
            isNew: false
        }
    },
    computed: mapGetters({
        userAccount: 'userAccount/userAccount'                
    }),
    methods: {
        goBack: function() {
            this.$router.go(-1);
        },
             
        _change(evt) {
            // this.$refs.excel_file.reset();
            const files = evt.target.files;            
            if(files == false && files[0] == false) 
                this.$refs.excel_file.reset();
            if(files && files[0])
                this._file(files[0]);
                
        },
        _change_new(evt) {
            const files = evt.target.files;            
            if(files == false && files[0] == false) 
                this.$refs.excel_file.reset();
            if(files && files[0])
                this._file_new(files[0]);
        },
        _file(file) {
			/* Boilerplate to set up FileReader */
			const reader = new FileReader();
			reader.onload = (e) => {
				/* Parse data */
				const bstr = e.target.result;
				const wb = XLSX.read(bstr, {type:'binary', raw: true});
				/* Get first worksheet */
				const wsname = wb.SheetNames[0];
				const ws = wb.Sheets[wsname];
				/* Convert array of arrays */
                const data = XLSX.utils.sheet_to_json(ws, {header:1, blankrows: false});                
                /* Update state */
                if(this.makeItems(data.slice(1)) == false) {                    
                    alert('필수 항목을 확인 해 주세요');
                    this.file = null;
                    this.itmes = [];
                    this.$refs.excel_file.reset();
                    return;
                }                    				
			};
            reader.readAsBinaryString(file);
            
        },
        _file_new(file) {
			/* Boilerplate to set up FileReader */
			const reader = new FileReader();
			reader.onload = (e) => {
				/* Parse data */
				const bstr = e.target.result;
				const wb = XLSX.read(bstr, {type:'binary', raw: true});
				/* Get first worksheet */
				const wsname = wb.SheetNames[0];
				const ws = wb.Sheets[wsname];
				/* Convert array of arrays */
                const data = XLSX.utils.sheet_to_json(ws, {header:1, blankrows: false});                
                /* Update state */
                if(this.makeItems_new(data.slice(1)) == false) {                    
                    alert('필수 항목을 확인 해 주세요');
                    this.file = null;
                    this.itmes = [];
                    this.$refs.excel_file.reset();
                    return;
                }                    				
			};
            reader.readAsBinaryString(file);
            
        },
        makeItems: function(data) {
            if(data == false) return false;
            this.isNew = false;            
            const vendorNo = 12002;
            const type = 10092;
            const gendor = 'M';            
            
            const tempItems = [];
            for(let i = 0; i < data.length; i++) {
                let item = data[i];
                
                let jsonItem = {};                                
                jsonItem.reqDate = item[3];
                jsonItem.reqUserName = item[6];
                jsonItem.reqUserPhoneNo = item[7];
                jsonItem.startPhoneNo = item[9];
                jsonItem.startAddr = item[10];
                jsonItem.receiverType = item[12];
                jsonItem.receiverName = item[13];
                jsonItem.receiverPhoneNo = item[14];
                jsonItem.receiverAddr = item[15];
                jsonItem.reservDate = item[17];
                jsonItem.carNo = item[20];
                jsonItem.option = item[23];
                jsonItem.etc = item[24];               
                tempItems.push(jsonItem);                
            }
            this.items = tempItems;
            
            return true;
        },
        makeItems_new: function(data) {
            if(data == false) return false;
            this.isNew = true;            
            const vendorNo = 12002;
            const type = 10092;
            const gendor = 'M';            
            
            const tempItems = [];
            for(let i = 0; i < data.length; i++) {
                let item = data[i];
                if(item[1].indexOf("접수") < 0) 
                    continue;

                let jsonItem = {};                                
                jsonItem.reqDate = item[0];
                jsonItem.reqUserName = item[4];
                jsonItem.reqUserPhoneNo = item[5];
                jsonItem.startPhoneNo = item[12];
                jsonItem.startAddr = item[13];
                jsonItem.receiverType = item[8];
                jsonItem.receiverName = item[13];
                jsonItem.receiverPhoneNo = item[21];
                jsonItem.receiverAddr = item[22];
                var reservDate = item[6];
                var reservTime = item[7];                
                jsonItem.reservDate = reservDate + ' ' + reservTime;
                jsonItem.carNo = item[16];

                var shuttle = item[9] == '신청함' ? 'Y' : 'N';
                var fast = item[10] == '신청함' ? 'Y' : 'N';                
                
                jsonItem.option = shuttle + ',' + fast;
                jsonItem.etc = item[19];               
                tempItems.push(jsonItem);                
            }
            this.items = tempItems;
            
            return true;
        },
        addOrders: async function(items) {
            if(confirm('총 ' + this.items.length + ' 건의 오더를 등록 하시겠습니까?') == false) return;
            this.$store.commit('common/' + types.Common.SPINNER_STATE, true);
            let resultMessage = new ResultMessage(); 
            if(this.isNew) {
                for(var i = 0; i < this.items.length; i++) {                
                    await this.addNewOrder(this.items[i]);
                    await sleep(250);                    
                }
            } else {
                for(var i = 0; i < this.items.length; i++) {                
                    await this.addOrder(this.items[i]);
                    await sleep(250);                    
                }
            }
            
            
            this.items = this.tempItems;  
            this.$forceUpdate();             
            this.$store.commit('common/' + types.Common.SPINNER_STATE, false);           
        },
        addOrder: async function(item) {
            let tempItem = {}
            try{
                let startAddr = await kakaoApi.getCoordinate(item.startAddr);                
                if(startAddr.data != false) {  
                    if(startAddr.data.meta.total_count > 0) {
                        let document = startAddr.data.documents[0];                        
                        item.startLat = document.x;
                        item.startLon = document.y; 
                    }
                }
                let endAddr = await kakaoApi.getCoordinate(item.receiverAddr);                
                if(endAddr.data != false) {  
                    if(endAddr.data.meta.total_count > 0) {
                        let document = endAddr.data.documents[0];                        
                        item.endLat = document.x;
                        item.endLon = document.y; 
                    }
                }
                await employeeApi.addOrder(item);
                tempItem = item;
            } catch(e) {
                tempItem = item;
                tempItem.orderNo = -1;
                this.tempItems.push(tempItem);
                
            }
        },
        addNewOrder: async function(item) {
            let tempItem = {}
            try{
                let startAddr = await kakaoApi.getCoordinate(item.startAddr);                
                if(startAddr.data != false) {  
                    if(startAddr.data.meta.total_count > 0) {
                        let document = startAddr.data.documents[0];                        
                        item.startLat = document.x;
                        item.startLon = document.y; 
                    }
                }
                let endAddr = await kakaoApi.getCoordinate(item.receiverAddr);                
                if(endAddr.data != false) {  
                    if(endAddr.data.meta.total_count > 0) {
                        let document = endAddr.data.documents[0];                        
                        item.endLat = document.x;
                        item.endLon = document.y; 
                    }
                }
                await employeeApi.addNewOrder(item);
                tempItem = item;
            } catch(e) {
                tempItem = item;
                tempItem.orderNo = -1;
                this.tempItems.push(tempItem);
                
            }
        }
    },
    mounted: function() {
        // 최초 로딩 데이터 조회
        // this.departmentList();
    }
}
</script>




// WEBPACK FOOTER //
// src/components/RegOrder.vue